import * as x from '../helpers/xmlHelpers';
import { ValuationAnalysis } from './valuationAnalysis';
import { Parties } from './parties';
import { Relationships } from './relationships';

export class InspectionDetail {
		constructor(doc)
		{
		this.label = null
		this.inspectionDate = null;
		this.propertyExteriorInspectionMethodType = null;
		this.propertyInteriorInspectionMethodType = null;


		this.label = x.getStringAttribute(doc,"xlink:label");
		this.inspectionDate = x.getMISMODateElement(doc, "./ns:InspectionDate");
		this.propertyExteriorInspectionMethodType = x.getStringElement(doc, "./ns:PropertyExteriorInspectionMethodType");
		this.propertyInteriorInspectionMethodType = x.getStringElement(doc, "./ns:PropertyInteriorInspectionMethodType");
	 }
}

export class InspectionServiceResponseDetail {
		constructor(doc)
		{
		this.label = null
		this.inspectorFileIdentifier = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.inspectorFileIdentifier = x.getStringElement(doc, "./ns:InspectorFileIdentifier");
	 }
}

export class InspectionServiceResponse {
		constructor(doc)
		{
		this.label = null
		this.inspectionServiceResponseDetail = null
		this.inspectionDetail = null
		//this.properties = []
		var node;
		//var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:INSPECTION_SERVICE_RESPONSE_DETAIL");
		if (node !== null)
				this.inspectionServiceResponseDetail = new InspectionServiceResponseDetail(node);

		node = x.selectSingleNode(doc, "./ns:PROPERTIES/ns:PROPERTY/ns:INSPECTIONS/ns:INSPECTION/ns:INSPECTION_DETAIL");
		if (node !== null)
				this.inspectionDetail = new InspectionDetail(node);

	 }
}

export class InspectionService {
		constructor(doc)
		{
		this.label = null
		this.inspectionServiceResponse = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:INSPECTION_SERVICE_RESPONSE");
		if (node !== null)
				this.inspectionServiceResponse = new InspectionServiceResponse(node);
	 }
}

export class ServiceDetail {
    constructor(doc)
    {
		//console.log("SD: ", doc)
		this.label = null
		this.serviceType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.serviceType = x.getStringElement(doc, "./ns:ServiceType");
   }
}

export class Service {
    constructor(doc)
    {
		this.label = null;
		this.inspectionService = null;
		this.valuationAnalysis = null;
		this.parties = null;
		this.relationships = null;
		this.serviceDetail = null;
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:INSPECTION_SERVICE");
		if (node !== null)
				this.inspectionService = new InspectionService(node);

		node = x.selectSingleNode(doc, "./ns:VALUATION/ns:VALUATION_RESPONSE/ns:VALUATION_ANALYSES/ns:VALUATION_ANALYSIS");
		if (node)
				this.valuationAnalysis = new ValuationAnalysis(node);

		this.parties = new Parties(doc);

		this.relationships = new Relationships(doc);

		node = x.selectSingleNode(doc, "./ns:SERVICE_DETAIL");
		if (node !== null)
				this.serviceDetail = new ServiceDetail(node);
   }
}

export class Services
{
	constructor(doc)
	{
		this.serviceList= [];
		var nodes;

			nodes = x.selectNodes(doc, "./ns:SERVICE");
			//console.log("services service: ", nodes.length, nodes);
			if (nodes.length > 0) {
					nodes.forEach ((svc) => {
							//console.log("svc: ", svc);
							var service = new Service(svc);
							//console.log("service: ", service);
							this.serviceList.push(service);
							var type = service.serviceDetail.serviceType;
							//console.log("service type: ", type)
							if (type === "Valuation")
									service.serviceType = "Valuation";
							else if (type === "Inspection")
									service.serviceType = "Inspection";
					});
			}
	}
	
	GetServiceByType(type) {
		var service = null;
		this.serviceList.forEach((svc) => {
			if (svc.serviceDetail.serviceType === type)
				service = svc;
		})

		return service;
	}

}
